import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8290e62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Landlord Details", -1))
const _hoisted_3 = {
  key: 0,
  class: "lookup-container"
}
const _hoisted_4 = { class: "telephone-input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asteriskVisible" }, "Phone or Mobile Number", -1))

import { PropType, computed, ref, onMounted, watch, inject } from "vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import ScrollView from "@/components/ui/scroll-view.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import SwitchContactLookup from "@/components/ui/lookup/switch-contact-lookup.vue";
import { ContactFindTypeRestriction } from "@/enums/contacts/ContactFindTypeRestriction";
import { Contacts } from "acquaint-api/models/Contacts";
import { mapAcquaintContactToLandlordPersonalInfo } from "@/utils/utility-switching/SwitchContactMapper";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { VueTelInput } from "vue-tel-input";
import { LandlordPersonalInfo } from "@/types/switches/LandlordPersonalInfo";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'landlord-details-landlord-switch',
  props: {
  /**
   * The personal information of the landlord.
   * @type {LandlordPersonalInfo}
   * @required
   */
  landlordDetails: {
    type: Object as PropType<LandlordPersonalInfo>,
    required: true,
  },

  /**
   * Indicates whether the telephone number provided is valid.
   * @type {boolean}
   * @required
   */
  telephoneNumberValid: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  "update:landlordDetails",
  "update:telephoneNumberValid",
],
  setup(__props, { emit }) {

const props = __props;

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;





const landlordPersonalInfo = computed({
  get: () => props.landlordDetails,
  set: (value: LandlordPersonalInfo) => emit("update:landlordDetails", value),
});

const screenWidth = ref(screen.width);
const smallScreen = computed(() => screenWidth.value < 769);

const onContactSelected = (e: Contacts) => {
  landlordPersonalInfo.value = mapAcquaintContactToLandlordPersonalInfo(e);
};

const fetchDetailsFillFields = async () => {
  if (landlordPersonalInfo.value.id <= 0) {
    return;
  }

  let selectedPropertyLandlord: Contacts;

  try {
    selectedPropertyLandlord = await apiClient.httpGet<Contacts>(
      `database/contacts/${landlordPersonalInfo.value.id}`,
    );
  } catch (err) {
    return;
  }

  if (selectedPropertyLandlord) {
    landlordPersonalInfo.value = mapAcquaintContactToLandlordPersonalInfo(
      selectedPropertyLandlord,
    );
  }
};

onMounted(() => {
  fetchDetailsFillFields();
});

watch(
  () => landlordPersonalInfo.value.id,
  () => {
    fetchDetailsFillFields();
  },
);

const preferredTelehoneNumbers = ["IE", "GB", "FR", "DE", "ES", "PL"];

const telehpneInputOptions = {
  required: true,
};

const telephoneNumberValid = computed({
  get: () =>
    props.telephoneNumberValid == undefined ||
    props.telephoneNumberValid == false
      ? false
      : true,
  set: (value: Boolean) =>
    emit(
      "update:telephoneNumberValid",
      value == undefined || value == false ? false : true,
    ),
});

const phoneNumberValidated = (e: any) => {
  telephoneNumberValid.value = e.valid;
};

const showLandlordLookup = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollView, null, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["landlord-details", { smallScreen: smallScreen.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (showLandlordLookup.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(SwitchContactLookup, {
                  "find-type-restriction": _unref(ContactFindTypeRestriction).PropertyOwners,
                  label: "Look up Landlord",
                  "results-max-width": "50%",
                  onContactSelected: onContactSelected,
                  toolTipId: "landlordDetailsSwitch",
                  toolTipTarget: "#landlordDetailsSwitch"
                }, {
                  "tooltip-content": _withCtx(() => [
                    _createTextVNode("Search for an existing contact to pre-fill the information below.")
                  ]),
                  _: 1
                }, 8, ["find-type-restriction"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(LookupSingleSelect, {
            modelValue: landlordPersonalInfo.value.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((landlordPersonalInfo.value.title) = $event)),
            "lookup-source": _unref(LookupTableSource).Titles,
            requiredInput: false,
            validationGroup: "landlord",
            label: "Title",
            "allow-zero-value": true
          }, null, 8, ["modelValue", "lookup-source"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((landlordPersonalInfo.value.firstName) = $event)),
            fieldValidation: _unref(ContactsValidation).FirstNames,
            label: "First Name",
            requiredInput: true,
            validationGroup: "landlord",
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "value-change-event"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((landlordPersonalInfo.value.lastName) = $event)),
            fieldValidation: _unref(ContactsValidation).LastName,
            label: "Last Name",
            requiredInput: true,
            validationGroup: "landlord",
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "value-change-event"]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(VueTelInput), {
              defaultCountry: 353,
              inputOptions: telehpneInputOptions,
              modelValue: landlordPersonalInfo.value.number,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((landlordPersonalInfo.value.number) = $event)),
              mode: "international",
              "valid-characters-only": true,
              onValidate: phoneNumberValidated,
              preferredCountries: preferredTelehoneNumbers
            }, null, 8, ["modelValue"])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})